import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CommonService } from 'src/services/common.service';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EnvServiceProvider } from './env.service.provider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LoginComponent } from './Login/Login.component';
 
import { ReportComponent } from './Report/Report.component';
import { DataTablesModule } from 'angular-datatables';
import { IndexComponent } from './Index/Index.component';
import { AuthInterceptor } from './auth.interceptor';

@NgModule({
  declarations: [				
    AppComponent,
      LoginComponent,
       
      ReportComponent,
      IndexComponent
   ],
  imports: [
    BrowserModule,
    NgbModule,
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    DataTablesModule,
     
  ],
  providers: [
    EnvServiceProvider,
    CommonService,
    // SECURITY: attaches Authorization: Bearer <token> to outgoing requests and
    // clears local auth state + redirects on 401/403 from the BE.
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
